<template>
  <ul class="awards-pages-nav">
    <li>
      <nuxt-link :to="$puLocalePath({ path: '/review-awards/' })"
        ><translate>UK</translate></nuxt-link
      >
    </li>
    <li>
      <nuxt-link :to="$puLocalePath({ path: '/review-awards/france/' })"
        ><translate>France</translate></nuxt-link
      >
    </li>
    <li>
      <nuxt-link :to="$puLocalePath({ path: '/review-awards/italy/' })"
        ><translate>Italy</translate></nuxt-link
      >
    </li>
    <li>
      <nuxt-link :to="$puLocalePath({ path: '/review-awards/spain/' })"
        ><translate>Spain</translate></nuxt-link
      >
    </li>
    <li>
      <nuxt-link :to="$puLocalePath({ path: '/review-awards/2023/' })">
        <translate :tt="{ year: 2023 }"> {year} Winners </translate>
      </nuxt-link>
    </li>
  </ul>
</template>
